export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// iframe嵌套动态路由
  {
    path: 'iframe/:menuCode',
    name: 'iframe',
    meta: {
      title: '',
      cache: true,
      isCheckMenu: false
    },
    component: function component() {
      return import('@/pages/extModule/iframe/iframe.vue');
    }
  } // // 合同管理-合同模板-合同条款查询
  // {
  //   path: 'content-management',
  //   name: 'content-management',
  //   meta: {
  //     title: 'CMS文章管理',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/cms/cmsArticle.vue')
  // },
  // {
  //   path: 'template',
  //   name: 'template',
  //   meta: {
  //     title: 'CMS模板管理',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/cms/cmsModel.vue')
  // },
  // {
  //   path: 'custom-model',
  //   name: 'custom-model',
  //   meta: {
  //     title: 'CMS模型管理',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/cms/cmsTemplate.vue')
  // },
  // {
  //   path: 'serviceConfigManage',
  //   name: 'serviceConfigManage',
  //   meta: {
  //     title: '流程分类管理',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/workflow/classifyWorkflow.vue')
  // },
  // {
  //   path: 'processList',
  //   name: 'processList',
  //   meta: {
  //     title: '流程设计管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/workflow/designWorkflow.vue')
  // },
  // {
  //   path: 'processVer',
  //   name: 'processVer',
  //   meta: {
  //     title: '流程实例管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/workflow/exampleWorkflow.vue')
  // },
  // {
  //   path: 'roleManagement',
  //   name: 'roleManagement',
  //   meta: {
  //     title: '角色管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/gn/roleGn.vue')
  // },
  // {
  //   path: 'management',
  //   name: 'management',
  //   meta: {
  //     title: '岗位管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/gn/postGn.vue')
  // },
  // {
  //   path: 'systemQuery',
  //   name: 'systemQuery',
  //   meta: {
  //     title: '应用管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/resources/apply.vue')
  // },
  // {
  //   path: 'menuManage',
  //   name: 'menuManage',
  //   meta: {
  //     title: '菜单管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/resources/menu.vue')
  // },
  // // 智能客服管理-配置信息-聊天气泡配置
  // {
  //   path: 'csChatBubbleConfig',
  //   name: 'csChatBubbleConfig',
  //   meta: {
  //     title: '聊天气泡配置',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csChatBubbleConfig.vue')
  // },
  // // 智能客服管理-会话管理-历史会话
  // {
  //   path: 'csHistorySession',
  //   name: 'csHistorySession',
  //   meta: {
  //     title: '历史会话',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csHistorySession.vue')
  // },
  // // 智能客服管理-常用语管理-公共常用语管理
  // {
  //   path: 'csPublicCommonWords',
  //   name: 'csPublicCommonWords',
  //   meta: {
  //     title: '公共常用语管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csPublicCommonWords.vue')
  // },
  // // 智能客服管理-常用语管理-个人常用语管理
  // {
  //   path: 'csPersonalCommonWords',
  //   name: 'csPersonalCommonWords',
  //   meta: {
  //     title: '个人常用语管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csPersonalCommonWords.vue')
  // },
  // // 智能客服管理-配置信息-机器人问答配置
  // {
  //   path: 'csRobotFaqConfig',
  //   name: 'csRobotFaqConfig',
  //   meta: {
  //     title: '机器人问答配置',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csRobotFaqConfig.vue')
  // },
  // // 智能客服管理-统计中心-满意度评价报表
  // {
  //   path: 'csSatisfactionEvaluationReport',
  //   name: 'csSatisfactionEvaluationReport',
  //   meta: {
  //     title: '满意度评价报表',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csSatisfactionEvaluationReport.vue')
  // },
  // // 智能客服管理-统计中心-客服统计报表
  // {
  //   path: 'csServiceStatisticsReport',
  //   name: 'csServiceStatisticsReport',
  //   meta: {
  //     title: '客服统计报表',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csServiceStatisticsReport.vue')
  // },
  // // 智能客服管理-会话管理-会话监控
  // {
  //   path: 'csSessionMonitoring',
  //   name: 'csSessionMonitoring',
  //   meta: {
  //     title: '会话监控',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csSessionMonitoring.vue')
  // },
  // // 智能客服管理-技能组管理-技能组管理
  // {
  //   path: 'csSkillGroupManage',
  //   name: 'csSkillGroupManage',
  //   meta: {
  //     title: '技能组管理',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csSkillGroupManage.vue')
  // },
  // // 智能客服管理-配置信息-基础系统应答配置
  // {
  //   path: 'csSysResConfig',
  //   name: 'csSysResConfig',
  //   meta: {
  //     title: '基础系统应答配置',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csSysResConfig.vue')
  // },
  // // 智能客服管理-配置信息-工作日配置
  // {
  //   path: 'csWorkdayConfig',
  //   name: 'csWorkdayConfig',
  //   meta: {
  //     title: '工作日配置',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/csWorkdayConfig.vue')
  // },
  // // 运营管理-智能客服管理-在线工作台
  // {
  //   path: 'opeCsOnlineWorkbench',
  //   name: 'opeCsOnlineWorkbench',
  //   meta: {
  //     title: '在线工作台',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/opeCsOnlineWorkbench.vue')
  // },
  // // 我的首页-智能客服管理-在线工作台
  // {
  //   path: 'supCsOnlineWorkbench',
  //   name: 'supCsOnlineWorkbench',
  //   meta: {
  //     title: '在线工作台',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/extModule/iframe/customerService/supCsOnlineWorkbench.vue')
  // }
  ]
};